import { render, staticRenderFns } from "./BS_settingInfo.vue?vue&type=template&id=200ac821&scoped=true&"
import script from "./BS_settingInfo.vue?vue&type=script&lang=js&"
export * from "./BS_settingInfo.vue?vue&type=script&lang=js&"
import style0 from "./BS_settingInfo.vue?vue&type=style&index=0&id=200ac821&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200ac821",
  null
  
)

export default component.exports